import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  Renderer2,
  ViewChild,
  ViewEncapsulation,
  ViewRef,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatSidenav } from '@angular/material/sidenav';
import { ActivatedRoute, ActivatedRouteSnapshot, Router } from '@angular/router';
import { CmsService, GlobalMessageService, ProductSearchPage, ProductSearchService } from '@spartacus/core';
import {
  BREAKPOINT,
  BreakpointService,
  PageLayoutService,
  ProductListComponent,
  ProductListComponentService,
  ViewConfig,
  ViewModes,
} from '@spartacus/storefront';
import { uniq } from 'lodash';
import { BehaviorSubject, Observable, Subscription, combineLatest } from 'rxjs';
import { distinct, switchMap, take } from 'rxjs/operators';
import { PLPState } from 'src/app/model/cache-page-state.model';
import { DealerPrice } from 'src/app/model/dealer-price.model';
import { CachePageStateService } from 'src/app/service/cache-page-state/cache-page-state.service';
import { ComponentService } from 'src/app/service/component.service';
import { ShimanoCountryService } from 'src/app/service/country/shimano-country.service';
import { DealerPriceService } from 'src/app/service/dealer-price/dealer-price.service';
import {
  GoogleTagManagerEvent,
  GoogleTagManagerProductListName,
  GoogleTagManagerService,
} from 'src/app/service/googletagmanager/google-tag-manager.service';
import { ShimanoLanguageService } from 'src/app/service/language/shimano-language.service';
import { PlpPopupService } from 'src/app/service/plp-popup/plp-popup.service';
import { ShimanoProductListComponentService } from 'src/app/service/product/shimano-product-list-component.service';
import { OBSOLETE_PRODUCTS, SnahCountryService } from 'src/app/service/snah/snah-countries.service';
import { StorageService } from 'src/app/service/storage/storage.service';
import { CurrentBusinessType } from 'src/app/utility/current-businesstype';

// @ts-ignore
@Component({
  selector: 'app-shimano-product-list',
  templateUrl: './shimano-product-list.component.html',
  styleUrls: ['./shimano-product-list.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class ShimanoProductListComponent extends ProductListComponent implements OnInit, OnDestroy {
  @ViewChild('sidenav', { static: false }) sidenav: MatSidenav;
  header = document.querySelector('header');
  bottomHeaderSlot = document.querySelector('.BottomHeaderSlot');
  footer = document.querySelector('footer');
  isSideNaveOpen = false;
  modelSubscription$: Subscription;
  dealerPriceCheckerSubscription$: Subscription;
  breakpointSubscription$: Subscription;
  isInfiniteScroll: boolean;
  mode: FormControl;

  model$: Observable<ProductSearchPage> = this.baseProductListComponentService.model$;

  viewMode$ = new BehaviorSubject<ViewModes>(null);
  ViewModes = ViewModes;

  productCodesList: string[] = [];
  baseProductCodesList: string[] = [];
  dealerPrices: DealerPrice[];

  isSearchPage = false;

  isGetProductListDone = true;
  productListResults: any[] = [];
  appendProducts = false;
  pageSize = 24;
  plpCurrentPage = 0;
  isLastPage = false;
  isEmpty = false;
  isLoadingProductListPage = true;
  impressionsListTotal: any[] = [];
  promotionsListTotal: any[] = [];
  hasDealerPrice = true;
  sideNavOpened = false;

  gtmbusinessType: string = this.currentBusinesstype.getBusinessType();
  affiliation = `/${this.gtmbusinessType}/${this.activeCountry}/${this.activeLanguage}`;
  product$: Observable<any>;
  basepriceBehaviorConfig$: Subscription;
  basepriceHidden = false;

  showObsoleteProduct$: Observable<boolean> = this.snahCountryService.getSnahFeatures(OBSOLETE_PRODUCTS);
  showObsoleteProductSubs: Subscription;

  cxRoute: string;
  plpCachingEnabled: boolean;
  cachedPageData: PLPState = null;
  cachedLastPage: number;
  productListElement: any =
    document.querySelector('cx-page-layout.ProductListPageTemplate') ??
    document.querySelector('cx-page-layout.SearchResultsListPageTemplate');

  plpPopupModalEnabled: Subscription;
  isPlpPopupEnabled: boolean;

  constructor(
    pageLayoutService: PageLayoutService,
    productListComponentService: ProductListComponentService,
    globalMessageService: GlobalMessageService,
    public scrollConfig: ViewConfig,
    private dealerPriceService: DealerPriceService,
    private cdr: ChangeDetectorRef,
    private cmsService: CmsService,
    private router: Router,
    private gtmService: GoogleTagManagerService,
    private componentService: ComponentService,
    private basePageLayoutService: PageLayoutService,
    private baseProductListComponentService: ProductListComponentService,
    private productSearchService: ProductSearchService,
    private breakpointService: BreakpointService,
    private currentBusinesstype: CurrentBusinessType,
    private countryService: ShimanoCountryService,
    private languageService: ShimanoLanguageService,
    private shimanoProductListComponentService: ShimanoProductListComponentService,
    private snahCountryService: SnahCountryService,
    private storageService: StorageService,
    private activatedRoute: ActivatedRoute,
    private cachePageStateService: CachePageStateService,
    private el: ElementRef,
    private renderer: Renderer2,
    private plpPopupService?: PlpPopupService
  ) {
    super(pageLayoutService, productListComponentService, globalMessageService, scrollConfig);
    this.isPlpPopupModalEnabled();
  }

  ngOnInit(): void {
    this.isPlpPopupModalEnabled();
    this.isPLPCachingEnabled();
    this.watchBackBtnBrowserClick();

    this.mode = new FormControl('over');
    this.productSearchService.clearResults();
    this.isInfiniteScroll = this.scrollConfig.view?.infiniteScroll?.active;

    this.basepriceBehaviorConfig$ = this.dealerPriceService.getBasepriceBehavior$().subscribe((hideBaseprice: any) => {
      if (hideBaseprice === 'true') {
        this.basepriceHidden = true;
      } else {
        this.basepriceHidden = false;
      }
      this.cdr.detectChanges();
    });

    this.showObsoleteProductSubs = this.showObsoleteProduct$
      .pipe(
        switchMap((showObsoleteProduct) => {
          if (showObsoleteProduct) {
            // emits on each route change
            return this.activatedRoute.queryParams;
          }
        })
      )
      .subscribe((routeChange) => {
        if (routeChange) {
          const url = this.getModifiedUrl();
          this.shimanoProductListComponentService.addInStockOutOfStockFlag(url);
        }
      });

    this.modelSubscription$ = this.model$.pipe(distinct()).subscribe((data) => {
      this.productCodesList = [];
      this.baseProductCodesList = [];

      if (data?.pagination?.currentPage > 0) {
        this.appendProducts = this.componentService.plpAppendProducts$.getValue();
        this.cachedLastPage = undefined;
      }

      if (this.cachedPageData) {
        this.plpCurrentPage = this.cachedLastPage;
      } else {
        if (!this.appendProducts) {
          this.productListResults = [];
          this.plpCurrentPage = 0;
        } else {
          this.plpCurrentPage = data.pagination?.currentPage;
        }
      }

      this.setProductResultsList(data);
      this.isLastPage = this.plpCurrentPage === data.pagination.totalPages - 1;
      this.appendProducts = false;
      this.isGetProductListDone = true;
      this.isLoadingProductListPage = false;

      // to disable/enable the scroll anchoring behavior of the browser
      this.isLastPage
        ? document.body.classList.remove('overflow-anchor')
        : document.body.classList.add('overflow-anchor');
      this.cdr.detectChanges();
    });

    this.cmsService
      .getCurrentPage()
      .pipe(take(1))
      .subscribe((currentPage) => {
        if (currentPage.pageId.startsWith('search')) {
          this.isSearchPage = true;
        }
      });

    this.dealerPriceCheckerSubscription$ = this.componentService.hasDealerPrice$.subscribe((hasDealerPrice) => {
      this.hasDealerPrice = hasDealerPrice;
      if (!(this.cdr as ViewRef).destroyed) {
        this.cdr.detectChanges();
      }
    });
  }

  setProductResultsList(data: any) {
    let products = this.cachedPageData?.productList ?? data.products;

    products.forEach((product: any) => {
      this.productListResults.push(product);
      this.productCodesList.push(product.code);
      this.baseProductCodesList.push(product.baseProduct);
    });

    if (products.length && products.length > 0) {
      this.isEmpty = false;
      if (this.cachedPageData) {
        this.componentService.plpDealerPrices$.next(this.cachedPageData.dealerPrices);
        this.dealerPrices = [...this.cachedPageData.dealerPrices];
      } else {
        this.getDealerPrices(uniq(this.productCodesList), this.appendProducts);
      }
    } else {
      this.isEmpty = true;
      this.router.navigateByUrl('/search-empty');
    }

    if (this.cachedPageData) {
      setTimeout(() => {
        // clear cached data after cachedPageData is loaded to PLP
        this.cacheCleanUp();
      });
    }
  }

  get activeCountry(): string {
    let activeCountry: string;
    this.countryService.getActive().subscribe((country) => (activeCountry = country));
    return activeCountry;
  }

  get activeLanguage(): string {
    let activeLanguage: string;
    this.languageService.getActive().subscribe((lang) => (activeLanguage = lang));
    return activeLanguage;
  }

  // viewPage(pageNumber: number): void {
  //   this.productListComponentService.viewPage(pageNumber);
  // }

  sortList(sortCode: string): void {
    this.baseProductListComponentService.sort(sortCode);
    this.componentService.fromSortBy$.next(true);
  }

  setViewMode(mode: ViewModes): void {
    this.viewMode$.next(mode);
    this.storageService.setLocalStorageitem('plpView', mode);
    this.cachedLastPage = undefined;
  }

  toggleSidenav(): void {
    // Hide the header, breadcrumbs and footer
    this.header.classList.add('d-none');
    this.bottomHeaderSlot.classList.add('d-none');
    this.footer.classList.add('d-none');

    // open the sidenav
    this.sidenav.toggle();
    this.isSideNaveOpen = true;
  }

  onClose(): void {
    // Show the header, breadcrumbs and footer
    this.header.classList.remove('d-none');
    this.bottomHeaderSlot.classList.remove('d-none');
    this.footer.classList.remove('d-none');
    this.isSideNaveOpen = false;
  }

  getDealerPrices(productCodes: string[], appendProducts: boolean) {
    this.dealerPriceService
      .getDealerPricesByProductCodes(productCodes)
      .pipe(take(1))
      .subscribe((data) => {
        if (appendProducts) {
          data.dealerPrices.forEach((dealerPrice: DealerPrice) => {
            this.dealerPrices?.push(dealerPrice);
          });
        } else {
          this.dealerPrices = data.dealerPrices;
        }
        this.componentService.plpDealerPrices$.next(this.dealerPrices);
        this.gtmProductListImpressions(this.productListResults);
        // this.gtmPromoView(this.productListResults);
        this.cdr.detectChanges();
      });
  }

  dealerPrice(productCode: string): number {
    if (this.dealerPrices) {
      return this.dealerPriceService.getDealerPriceValueByProductCode(this.dealerPrices, productCode);
    }
  }

  gtmProductListImpressions(products: any[]) {
    const impressionsList: any[] = [];
    const promotionsList: any[] = [];
    let impressionsListForGtm: any[];
    let promotionsListForGtm: any[];
    products.forEach((product, index) => {
      impressionsList.push({
        item_id: product.baseProduct,
        item_name: product.baseProductName,
        affiliation: this.affiliation,
        index: index,
        item_brand: '',
        price: this.dealerPrice(product.code),
        item_list_name: this.isSearchPage
          ? GoogleTagManagerProductListName.SEARCH_PAGE
          : GoogleTagManagerProductListName.PLP,
      });
      if (product.potentialPromotions && product.potentialPromotions.length) {
        promotionsList.push({
          promotion_id: product.potentialPromotions[0].code,
          promotion_name: product.potentialPromotions[0].description,
          creative_slot: GoogleTagManagerProductListName.PLP,
          items: [
            {
              item_id: product.baseProduct,
              item_name: product.baseProductName,
              affiliation: this.affiliation,
              index: index,
              item_brand: '',
              price: product.basePrice.formattedValue,
            },
          ],
        });
      }
    });
    this.impressionsListTotal.push(impressionsList);
    this.promotionsListTotal.push(promotionsList);
    const prevListIndex = this.impressionsListTotal.length - 2;
    const newListIndex = this.impressionsListTotal.length - 1;
    if (newListIndex) {
      impressionsListForGtm = this.impressionsListTotal[newListIndex].filter(
        (newList: { id: any }) =>
          !this.impressionsListTotal[prevListIndex].some((prevList: { id: any }) => newList.id === prevList.id)
      );
      promotionsListForGtm = this.promotionsListTotal[newListIndex].filter(
        (newList: { productCode: any }) =>
          !this.promotionsListTotal[prevListIndex].some(
            (prevList: { productCode: any }) => newList.productCode === prevList.productCode
          )
      );
    } else {
      impressionsListForGtm = this.impressionsListTotal[0];
      promotionsListForGtm = this.promotionsListTotal[0];
    }
    const gtmTag = {
      event: GoogleTagManagerEvent.PRODUCT_IMPRESSION,
      ecommerce: {
        currency: this.storageService.getSessionStorageItem('currency'),
        items: impressionsListForGtm,
      },
    };
    this.gtmService.pushTag({
      ecommerce: null,
      search_term: '',
      results_page: '',
      affiliation: '',
      content_type: '',
      content_id: '',
      content_name: '',
    });
    this.gtmService.pushTag(gtmTag);
    this.gtmPromoView(
      promotionsListForGtm.map((promotion) => {
        const removeProperty = (propKey: string, { [propKey]: propValue, ...rest }: any) => rest;
        return removeProperty('productCode', promotion);
      })
    );
  }

  gtmPromoView(promotionsList: any) {
    if (promotionsList.length) {
      promotionsList.forEach((item: any) => {
        const gtmTag = {
          event: GoogleTagManagerEvent.PROMO_VIEW,
          ecommerce: item,
        };
        this.gtmService.pushTag({
          ecommerce: null,
          search_term: '',
          results_page: '',
          affiliation: '',
          content_type: '',
          content_id: '',
          content_name: '',
        });
        this.gtmService.pushTag(gtmTag);
      });
    }
  }

  getModifiedUrl(): any {
    const route: ActivatedRouteSnapshot = this.activatedRoute.snapshot;
    const page = route.data.cxRoute;
    const currentUrl = this.router.url;
    let modifiedUrl;

    if (!this.componentService.fromProductRefinement$.value && !this.componentService.fromSortBy$.value) {
      if (page === 'category') {
        // scenario where user comes from search bar then is redirected to /category, and has query params
        if (route.queryParams.query) {
          modifiedUrl = currentUrl;
        } else {
          modifiedUrl = currentUrl + '?query=:relevance:category:' + route.params.categoryCode;
        }
      } else if (page === 'search') {
        let keywordSearch = encodeURIComponent(route.params.query.trim());
        // scenario where on /search and has query params
        if (route.queryParams.query) {
          modifiedUrl = currentUrl;
        } else {
          modifiedUrl = currentUrl + '?query=' + keywordSearch + ':relevance';
        }
      }
      return modifiedUrl;
    } else {
      this.componentService.fromProductRefinement$.next(false);
      this.componentService.fromSortBy$.next(false);
    }
  }

  isPLPCachingEnabled(): void {
    this.cachePageStateService
      .getPLPCachingEnabledConfig$()
      .pipe(take(1))
      .subscribe((enabled) => {
        this.plpCachingEnabled = enabled;
        this.setPLPView();
      });
  }

  enablePLPCaching() {
    const page = this.activatedRoute.snapshot.data.cxRoute;
    const element: any =
      document.querySelector('cx-page-layout.ProductListPageTemplate') ??
      document.querySelector('cx-page-layout.SearchResultsListPageTemplate');

    const data: PLPState = {
      productList: this.productListResults,
      dealerPrices: this.dealerPrices,
      lastPage: this.plpCurrentPage,
      scrollPosition: window.scrollY,
      elementHeight: element.offsetHeight,
    };

    this.cachePageStateService.enableCacheOnPage(page, data);
  }

  cacheCleanUp() {
    this.cachedPageData = null;
    this.renderer.removeStyle(this.productListElement, 'height');
    this.cachePageStateService.clearPage(this.cxRoute);
  }

  watchBackBtnBrowserClick(): void {
    combineLatest([this.activatedRoute.queryParams, this.activatedRoute.params]).subscribe((data) => {
      this.cxRoute = this.activatedRoute.snapshot.data.cxRoute;
      this.cachedLastPage = undefined;

      if (this.cachePageStateService.isNavigatedViaBackBtn()) {
        this.cachedPageData = this.cachePageStateService.getCachedPage(this.cxRoute);

        if (this.cachedPageData) {
          // reload last scroll position
          this.renderer.setStyle(this.productListElement, 'height', `${this.cachedPageData.elementHeight}px`);
          window.scroll(0, this.cachedPageData.scrollPosition);
          this.cachedLastPage = this.cachedPageData.lastPage;
        }
      }
    });
  }

  setPLPView(): void {
    this.breakpointSubscription$ = this.breakpointService.breakpoint$.subscribe((breakpoint) => {
      if (breakpoint === BREAKPOINT.xl) {
        const savedPLPView = this.plpCachingEnabled ? this.storageService.getLocalStorageItem('plpView') : null;
        this.viewMode$.next(savedPLPView === 'grid' ? ViewModes.Grid : ViewModes.List);
        this.sideNavOpened = false;
      } else {
        this.viewMode$.next(ViewModes.List);
      }
    });
  }

  isPlpPopupModalEnabled = () => {
    this.plpPopupModalEnabled = this.plpPopupService.getPlpPopupEnabledConfig$().subscribe((plpPopup) => {
      this.isPlpPopupEnabled = plpPopup.toString() === 'true';
      this.componentService.plpPopupEnabled$.next(this.isPlpPopupEnabled);
      this.cdr.detectChanges();
    });
  };

  ngOnDestroy(): void {
    this.showObsoleteProductSubs?.unsubscribe();

    if (this.plpCachingEnabled) {
      this.enablePLPCaching();
    }
    if (this.modelSubscription$) {
      this.modelSubscription$.unsubscribe();
    }
    if (this.dealerPriceCheckerSubscription$) {
      this.dealerPriceCheckerSubscription$.unsubscribe();
    }
    if (this.basepriceBehaviorConfig$) {
      this.basepriceBehaviorConfig$.unsubscribe();
    }
    this.breakpointSubscription$?.unsubscribe();

    if (this.plpPopupModalEnabled) {
      this.plpPopupModalEnabled.unsubscribe();
    }
  }
}
